<section class="lap" role="status" aria-live="polite" [attr.aria-busy]="loading">
  <div class="lap-card">
    <div *ngIf="loading" class="lap-loading">
      <span class="lap-spinner" aria-hidden="true"></span>
      <p class="lap-loading-text">{{ loadingMessage }}</p>
    </div>

    <ng-container *ngIf="!loading">
      <div class="lap-visual" aria-hidden="true">
        <div class="lap-icon-ring">
          <i class="fas fa-plug-circle-xmark lap-icon"></i>
        </div>
      </div>

      <h2 class="lap-title">{{ resolvedTitle }}</h2>
      <span *ngIf="featureTag" class="lap-chip">{{ featureTag }}</span>

      <p class="lap-body">{{ resolvedMessage }}</p>

      <div class="lap-callout" *ngIf="!showCustomHint">
        <p class="lap-callout-heading">Qué puedes hacer</p>
        <ol class="lap-steps">
          <li>Descarga e instala el complemento en este equipo.</li>
          <li>Ejecútalo en segundo plano.</li>
          <li>Pulsa <strong>Actualizar</strong> para comprobar la conexión.</li>
        </ol>
      </div>
      <div class="lap-callout lap-callout--plain" *ngIf="showCustomHint">
        <p>{{ hint }}</p>
      </div>

      <div class="lap-actions">
        <a
          *ngIf="useHttpLink"
          [href]="httpHref"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-primary lap-btn"
          aria-label="Descargar complemento de firma">
          <i class="fas fa-download" aria-hidden="true"></i>
          Descargar complemento
        </a>
        <button
          *ngIf="!useHttpLink"
          type="button"
          class="btn btn-primary lap-btn"
          (click)="obtain.emit()"
          aria-label="Obtener complemento de firma">
          <i class="fas fa-download" aria-hidden="true"></i>
          Obtener complemento
        </button>
        <button type="button" class="btn btn-secondary lap-btn" (click)="refresh.emit()" aria-label="Comprobar de nuevo si el complemento está en ejecución">
          <i class="fas fa-rotate" aria-hidden="true"></i>
          Comprobar de nuevo
        </button>
      </div>

      <div class="lap-meta" aria-label="Información de versión del complemento">
        <p class="lap-release">{{ resolvedReleaseLabel }}</p>
        <p class="lap-checksum" *ngIf="resolvedChecksum">SHA-256: <code>{{ resolvedChecksum }}</code></p>
      </div>
    </ng-container>
  </div>
</section>
